module.exports = __webpack_public_path__ + "assets/img/arrowRight.c615e527.svg";